module.exports = __webpack_public_path__ + "img/正常.a1cea17f.png";